export default __webpack_public_path__ + "74c09f3.png";